import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { marginType } from "../../../shared/margin-type/margin-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-margin-type-select",
  templateUrl: "./margin-type-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class MarginTypeSelectComponent implements OnInit {
  public readonly marginTypeChange = output();
  @Input() public marginType = "Select margin type";
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public marginTypeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildMarginTypeList();
  }

  public onMarginTypeChange(event) {
    this.marginTypeChange.emit(event.value);
  }

  private buildMarginTypeList() {
    Object.keys(marginType).map((key) => {
      this.marginTypeList.push({
        label: marginType[key],
        value: key,
      });
    });
  }
}
